import { render } from "./OAuthCallbackComponent.vue?vue&type=template&id=7f48f1c9"
import script from "./OAuthCallbackComponent.vue?vue&type=script&lang=js"
export * from "./OAuthCallbackComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__